module.exports = __webpack_public_path__ + "static/img/65-3.dc59c34.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/65-3.jpg
// module id = YKcJ
// module chunks = 0